import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';

import CaretIcon from 'modules/Common/components/svg/CaretIcon';

export default class SectionLink extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    to: PropTypes.string
  };

  render() {
    const {className = "section-link", to} = this.props;

    return (
      <h2 className={className}>
        {to ?
          <Link to={to} className={`${className}-row`}>
            <span className={`${className}-row-text`}>{this.props.children}</span>
            <span className={`${className}-row-caret`}><CaretIcon type="line" direction="right"/></span>
          </Link>
          :
          this.props.children
        }
      </h2>
    );
  }
}


// WEBPACK FOOTER //
// ./modules/Common/components/SectionLink.js